import { createGlobalStateHook } from '@dateam/ark-react';

const initStartedGlobal = createGlobalStateHook<App.InitStarted>(false);

export const useInitStarted = initStartedGlobal.hook;
export const setInitStarted = initStartedGlobal.setState;
export const getInitStarted = initStartedGlobal.getState;